import React from "react";
import ReactDOM from "react-dom/client";

import App from "./core/App";
import Dashboard from "./Dashboard";

import "common/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App
    title="Административен панел на Български пощи"
    dashboard={Dashboard}
    locale="bg"
  />,
);
